import { FlexCol } from '@/components/ui/flex';
import { Link } from 'react-router-dom';
import { Button } from '../ui/button';

export function Page404() {
  return (
    <FlexCol className="h-screen bg-background items-center justify-center">
      <FlexCol
        gap="4"
        className="items-center justify-center max-w-md text-center"
      >
        <h1 className="text-6xl font-bold">404</h1>
        <h2 className="text-2xl font-semibold text-secondary">
          Page Not Found
        </h2>
        <p className="text-lg text-secondary">
          The page you are looking for does not exist.
        </p>
        <Link to="/">
          <Button size="lg">View my Workspaces</Button>
        </Link>
      </FlexCol>
    </FlexCol>
  );
}
